import { derived, get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';

const STORAGE_KEY = 'shelly_dev_reorder_step_controls';

const readInitialValue = (): boolean => {
	if (!isNonProductionAppBuild()) return false;
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * Dev/staging: phone up/down and previous/next controls in list reorder mode.
 * Default on for non-production builds; always off in production.
 * Preference is local-only and can be toggled from the Dev Modal.
 */
export const reorderStepControlsEnabled = writable<boolean>(readInitialValue());

reorderStepControlsEnabled.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const reorderStepControlsAvailable = derived(
	reorderStepControlsEnabled,
	($enabled) => isNonProductionAppBuild() && $enabled,
);

export const isReorderStepControlsAvailable = (): boolean => get(reorderStepControlsAvailable);

export const setReorderStepControlsEnabled = (enabled: boolean) => {
	reorderStepControlsEnabled.set(isNonProductionAppBuild() ? enabled : false);
};
